// extracted by mini-css-extract-plugin
export default {"history-btn":"UserHistoryButton_history-btn__L9yli"};